<template>
    <component :is="template">
        <div>
            <!-- S: PC 슬라이드 배너 -->
            <main-slide v-if="!$vuetify.breakpoint.mobile && ready" :banners="pcBanners" v-on="{ open }" />
            <!-- E: PC 슬라이드 배너 -->

            <!-- S: Mobile 슬라이드 배너 -->
            <main-mobile-slide v-if="$vuetify.breakpoint.mobile && ready" :banners="mobileBanners" v-on="{ open }" />
            <!-- E: Mobile 슬라이드 배너 -->

            <v-container class="px-0 px-lg-12px">
                <main-profile />
                <main-button-group />
            </v-container>

            <section class="main-section best-seller">
                <v-container>
                    <div class="tit-wrap text-center">
                        <h2 class="tit tit--lg">베스트 셀러</h2>
                    </div>
                    <product-list skin="main" is-main category-code="bestseller" limit="8" class="main-product-list" />
                </v-container>
            </section>

            <main-book-of-the-month />

            <section class="main-section" style="background-color: #f9f9f9">
                <v-container>
                    <div class="tit-wrap text-center">
                        <h2 class="tit tit--lg">교환 가능 상품</h2>
                    </div>
                    <partners-slide />
                </v-container>
            </section>
        </div>

        <popup-layer code="main" />
    </component>
</template>
<script>
import api from "@/api";
import ProductList from "@/components/client/shop/product/product-list.vue";
import PartnersSlide from "@/components/client/main/partners-slide.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainProfile from "@/components/client/main/main-profile.vue";
import MainButtonGroup from "@/components/client/main/main-button-group.vue";
import MainSlide from "@/components/client/main/main-slide.vue";
import MainMobileSlide from "@/components/client/main/main-mobile-slide.vue";
import MainBookOfTheMonth from "@/components/client/main/main-book-of-the-month.vue";

import { mdiPlay, mdiPause, mdiPlus, mdiClose } from "@mdi/js";
export default {
    components: {
        ProductList,
        PartnersSlide,
        PopupLayer,
        MainSlide,
        MainMobileSlide,
        MainProfile,
        MainButtonGroup,
        MainBookOfTheMonth,
    },
    data() {
        return {
            mdiPlay,
            mdiPause,
            mdiPlus,
            mdiClose,
            model: 0,

            slideIndex: 0,

            cycle: true,
            dialog: false,
            pcBanners: [],
            mobileBanners: [],

            ready: false,

            banners: [
                {
                    src: "/images/main/banner-m7.jpg",
                    open: "https://smartstore.naver.com/korea-books/products/9569341704?NaPm=ct%3Dlu6lheh4%7Cci%3Da28d13e3474197d3d86794830e2b632e3b2e5609%7Ctr%3Dsls%7Csn%3D627310%7Chk%3D2ec2dd599537149cc34a8018bc4d870bff09308d",
                },
                {
                    src: "/images/main/banner-m1.jpg",
                    to: "/shop/ebook",
                },
                {
                    src: "/images/main/banner-m2.jpg",
                    to: "/join",
                },
                {
                    src: "/images/main/banner-m3.jpg",
                    to: "/gshop/brand",
                },
                {
                    src: "/images/main/banner-m4.jpg",
                    to: "/shop/discount",
                },
                {
                    src: "/images/main/banner-m5.jpg",
                    to: "/shop/independent",
                },
                {
                    src: "/images/main/banner-m6.jpg",
                    to: "/shop/bestseller",
                },
            ],
        };
    },
    async mounted() {
        if (!window.sessionStorage.getItem("history")) {
            await api.v1.history.post();
            window.sessionStorage.setItem("history", "history");
        }
        await this.init();
    },
    methods: {
        async init() {
            this.ready = false;
            let { banners: pcBanners } = await api.v1.common.banners.gets({ params: { type: "pc" } });
            let { banners: mobileBanners } = await api.v1.common.banners.gets({ params: { type: "mobile" } });
            this.pcBanners = pcBanners;
            this.mobileBanners = mobileBanners;
            console.log({ pcBanners, mobileBanners });
            this.ready = true;
        },
        open(url) {
            window.location.href = url;
        },
        stop() {
            if (!this.cycle) {
                this.cycle = true;
            } else {
                this.cycle = false;
            }
        },
        close() {
            this.dialog = false;
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.main}`);
        },
    },
    metaInfo: {
        link: [{ rel: "canonical", href: "https://www.daehanbooks.co.kr" }],
    },
};
</script>

<style scoped>
.best-seller {
    /* background: url("/images/main/section-product-background.png") no-repeat top 10px center; */
}
.slide-controls {
    position: absolute;
    z-index: 5;
    bottom: 20px;
    max-width: 1230px;
    padding: 0px 12px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.counter {
    margin-left: 40px;
    background-color: grey;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
}
.main-dialog-img {
    width: 100%;
    display: block;
}
.mdiclose {
    justify-content: flex-end;
}
.close-box {
    position: fixed;
    right: 20px;
    top: 10px;
    width: auto;
    box-shadow: none !important;
    background-color: transparent;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .slide-controls {
        bottom: 120px;
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
